import { render, staticRenderFns } from "./TestimonialSettings.vue?vue&type=template&id=6e3fd5b2&scoped=true&"
import script from "./TestimonialSettings.vue?vue&type=script&lang=js&"
export * from "./TestimonialSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3fd5b2",
  null
  
)

export default component.exports